import React, { useEffect } from "react";
import { Button, Tree, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { FormBox } from "./FormBox";
import { EventDataNode, DataNode } from "antd/lib/tree";
import { useDictModel } from "../dictModel";
import { ISCMDictDetail } from "../dictService";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export const DataBox = () => {
    const { treeSource, loadData, setMode, setSelectedNodes, selectedNodes, setFormVal } = useDictModel();

    useEffect(() => {
        loadData();
    }, [])
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    //字典选中事件
    const onSelect = (selectedKeys: React.Key[], info: {
        event: "select";
        selected: boolean;
        node: EventDataNode;
        selectedNodes: DataNode[];
        nativeEvent: MouseEvent;
    }) => {
        let selectNode = info.selectedNodes as ISCMDictDetail[];
        setMode(info.selected ? "edit" : "");
        setSelectedNodes(selectNode);
        setFormVal(selectNode[0]);
    };


    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (selectedNodes.length <= 0) {
                    // message.warning("请选择要增加的父级");
                    message.warning(Locale["Select the parent field you want to add."]);
                    return;
                }
                // message.success("增加下级模式开启");
                message.success(Locale["Enable mode of adding subordinate field."]);
                setMode("nextInsert");
            }}
        >{Locale["Add subordinates"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (selectedNodes.length <= 0) {
                    // message.warning("请选择要增加的同级");
                    message.warning(Locale["Select the brother field you want to add."]);
                    return;
                }
                // message.success("增加同级模式开启");
                message.warning(Locale["Enable mode of adding brother field."]);
                setMode("add");
            }}
        >{Locale["Add sibling"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (selectedNodes.length <= 0) {
                    // message.warning("请选择要删除的节点");
                    message.warning(Locale["Please select the node to delete."]);
                    return;
                }
            }}
            disabled
        >{Locale["Delete"]}</Button>
    </>;

    return (
        <YhBox title={Locale["Data dictionary"]} action={action}>
            <div className="dict-container flex">
                <div className="dict-list-box">
                    <Tree
                        selectedKeys={[selectedNodes[0]?.key]}
                        titleRender={(node: any) => `${node.name}`}
                        onSelect={onSelect}
                        treeData={treeSource}
                    />
                </div>
                <div className="dict-from-box flex">
                    {selectedNodes.length > 0 ?
                        <FormBox />
                        :
                        <div className="dict-init-box flex flex-1 items-center justify-center">{Locale["Data dictionary"]}</div>
                    }
                </div>
            </div>
        </YhBox>
    )
}